import React, { useState } from 'react';
import { Col, Row } from 'reactstrap';
import * as XLSX from 'xlsx';
import { Popover, Button, Modal as AntDModal } from 'antd'; // Import Popover
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faEye, faDownload } from '@fortawesome/free-solid-svg-icons';
import { DocumentPreview } from './DocumentPreview/DocumentPreview';

export default function PreviewAndDownload({ attachments, getIconByType }) {
  const [selectedAttachment, setSelectedAttachment] = useState(null);
  const [selectedAttachmentIndex, setSelectedAttachmentIndex] = useState(null);
  const [contextPosition, setContextPosition] = useState(null); 
  const [showPriview, setShowPriview] = useState(null); 

 const getPDFPrevModal = () => {
    return (
      <AntDModal
        rootClassName='docuPreview'
        open={showPriview}
        title={
          showPriview?.FileName
        }
        width={900}
        style={{ top: 170, borderRadius: 50 }}
        onCancel={()=>setShowPriview(null)}
        footer={null}
      > 
        <DocumentPreview base64String={showPriview?.base64String} />
      </AntDModal>
    )
  }
  const downloadFile = (base64String,fileName) => { 
    const byteCharacters = atob(base64String);
    const byteNumbers = new Array(byteCharacters.length);
    for (let i = 0; i < byteCharacters.length; i++) {
        byteNumbers[i] = byteCharacters.charCodeAt(i);
    }
    const byteArray = new Uint8Array(byteNumbers); 
    const blob = new Blob([byteArray], { type: 'application/octet-stream' }); 
    const url = URL.createObjectURL(blob); 
    const a = document.createElement('a');
    a.href = url;
    a.download = fileName;
    document.body.appendChild(a);
    a.click();
    document.body.removeChild(a); 
    URL.revokeObjectURL(url);
  };

  const handlePreview = () => {
    let base64String=selectedAttachment?.compressedBase64;
    let FileName=selectedAttachment?.attachmentName;
    setShowPriview({base64String:base64String,FileName:FileName})
  };
 
  const handleDownload = () => {
    let base64String=selectedAttachment?.compressedBase64;
    let FileName=selectedAttachment?.attachmentName;
    downloadFile(base64String,FileName);
  };
 
  const handleContextMenu = (e, att,index) => {
    e.preventDefault();  
    setSelectedAttachment(att);
   setSelectedAttachmentIndex(index);
    setContextPosition({
      top: e.clientY + 10, 
      left: e.clientX + 10,  
    });
  };
 function checkIfDocx(base64) {
    try {
                XLSX.read(base64, { type: 'base64' }); 
                return true;
            } catch (err) {
                return false;
            }
 }
  const contextMenu = (
    <div>
      {checkIfDocx(selectedAttachment?.compressedBase64)&&
      <Button style={{ width: '100%' }} onClick={handlePreview}>
        <FontAwesomeIcon icon={faEye} /> Preview
      </Button>}
      <Button style={{ width: '100%' }} onClick={handleDownload}>
        <FontAwesomeIcon icon={faDownload} /> Download
      </Button>
    </div>
  );

  return (
    <div>
      {getPDFPrevModal()}
      <Row style={{marginLeft:'0px'}}>
        {attachments?.map((att, index) => {
          return (
            <Col
              sm={2}
              title={att?.attachmentName}
              style={{ position: 'relative',height: '2rem'}}
              className="Attachment-Card"
              key={att?.attachmentName}
              onContextMenu={(e) => handleContextMenu(e, att,index)} 
            >
              <Popover
                content={contextMenu} 
                open={selectedAttachmentIndex === index} 
                placement="bottomLeft"  
                style={{
                  position: 'absolute',
                  top: contextPosition?.top,
                  left: contextPosition?.left,
                  zIndex: 9999,
                }}
                trigger="click"  
                onOpenChange={() => setSelectedAttachmentIndex(null)} 
              >
                <div style={{display: 'flex', gap:'3px'}}>
                  <span>{getIconByType(att?.attachmentName)}</span>
                  <span className="Name">{att?.attachmentName}</span>
                </div>
              </Popover>
            </Col>
          );
        })}
      </Row>
    </div>
  );
}
